import React from "react";
import {AppStore} from "./store/app.store";
import {AppService} from "./service/app.service";
import {TranslationService} from "./service/module/translation.service";

interface StoreContextInterface {
    appStore: AppStore,
}

export const StoreContext = React.createContext<StoreContextInterface>({
    appStore: new AppStore(new AppService(), new TranslationService()),
})